export default class Banner {
  constructor(title, link, image, isPublished = false) {
    this.title = title;
    this.link = link;
    this.image = image;
    this.is_published = isPublished;
  }
}
